import { BLOCK_TEMPLATE } from "../models";

export const INITIAL_BROADCAST_PAGE_MODEL = {
    backgroundUrl: '',
    backgroundFixed: true,
    showTitle: true,
    titleSize: '24px',
    titleBold: false,
    showSubtitle: true,
    subtitleSize: '16px',
    subtitleBold: false,
    headerAlign: 'flex-start',
    titleRu: 'Трансляция',
    titleEn: 'Broadcast',
    askQuestionAccentStyle: true,
};

export const ELEMENT_POSITIONING = (locale) => [
    {
        label: locale('settings.left'),
        value: 'flex-start',
    },
    {
        label: locale('settings.center'),
        value: 'center',
    },
    {
        label: locale('settings.right'),
        value: 'flex-end',
    },
];

export const BROADCAST_BLOCKS_LIST = [
    {
        template: BLOCK_TEMPLATE.PLAYER,
    },
    {
        template: BLOCK_TEMPLATE.POSTER,
    },
    {
        template: BLOCK_TEMPLATE.HALL_DESCRIPTION,
        checkModule: 'moduleEpisode',
    },
    {
        template: BLOCK_TEMPLATE.HALL_EPISODES,
        checkModule: 'moduleEpisode',
    },
    {
        template: BLOCK_TEMPLATE.QUIZZES,
        allowMultiple: true,
    },
];
